import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgSwiggy = function SvgSwiggy(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35 0H0v35h35V0ZM17.482 30.137l.053.042.002.001.11-.125c.909-1.035 6.875-7.824 7.866-13.365.117-.663-.017-1.172-.366-1.438-.525-.4-1.314-.617-3.191-.617h-2.391l-1.128.001a.347.347 0 0 1-.282-.337l-.01-4.055a.464.464 0 0 1 .929-.002l.006 2.984c0 .075.043.252.215.297 1.122.3 6.792.081 6.704-.947v-.012C25.518 8.308 21.908 5 17.525 5c-1.38 0-2.686.328-3.842.91-2.769 1.424-4.734 4.297-4.683 7.615.036 2.353 1.587 6.534 2.536 7.154.326.215.731.21 1.993.194.425-.006.947-.013 1.597-.013 1.169 0 2.256.003 2.792.006.054.011.347.078.347.346l.005 3.082a.463.463 0 1 1-.926.003s.022-1.238.022-1.698v-.009c0-.108 0-.285-.304-.42-1.026-.458-4.359-.182-4.546.322-.072.194.3.944.874 1.904a66.794 66.794 0 0 0 4.091 5.74Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgSwiggy;